import React, { useMemo } from 'react'
import Switch from '.'

/**
 * Renders a controlled Switch component.
 * @param {Object} props - The props object.
 * @param {string} props.name - The name of the switch. (Hook-Form related)
 * @param {string} props.label - The label for the switch.
 * @param {boolean} [props.checked=false] - The value of the switch.
 * @param {Function} props.onChange - The function to be called when the switch changes.
 * @param {string} [props.className] - The classes for the switch container.
 * @returns {React.ReactElement} - The Switch component.
 *
 * For styling, please refer to src/components/inputs/Switch/styles.js
 */
export function BaseSwitch({ name, label, checked, onChange, className = '', ...rest }) {
  const inputId = useMemo(() => `Refera__Switch-${name}-${crypto.randomUUID()}`, [name])
  return (
    <Switch.Root className={className}>
      <Switch.Label htmlFor={inputId} content={label} />
      <Switch.Control id={inputId} name={name} checked={checked} onChange={onChange} {...rest} />
    </Switch.Root>
  )
}
